import LinearDiagramWithCheckbox from './LinearDiagramWithCheckbox';

export default LinearDiagramWithCheckbox;
